import { spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

type FieldRowProps = {
  error?: boolean;
};

type MarginBottomProps = {
  marginBottom?: keyof typeof spacing;
};

export const FieldRow = styled.div<FieldRowProps>`
  ${({ error }) => css`
    display: grid;
    gap: ${spacing.medium};
    grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
    margin-bottom: ${error ? `3rem` : spacing.medium};

    p {
      bottom: -1.5rem;
    }
  `}
`;

export const FieldGroup = styled.div<MarginBottomProps>`
  ${({ marginBottom }) => css`
    margin-bottom: ${marginBottom ? spacing[marginBottom] : spacing.large};
  `}
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  button {
    align-self: center;
  }
`;
